import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=b3bd79e8&scoped=true&"
import script from "./NewTemplate.vue?vue&type=script&lang=js&"
export * from "./NewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=b3bd79e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd79e8",
  null
  
)

export default component.exports